import RenderHTML from '../ui-components/RenderHTML'

export const AddPaymentMethod = ({
  addType,
  onAdd,
  isDisabled,
  caption
}: {
  addType: 'bank' | 'upi'
  onAdd?: () => void
  isDisabled?: boolean
  caption?: string
}) => {
  return (
    <div
      onClick={isDisabled ? undefined : onAdd}
      test-locator={
        addType === 'bank'
          ? `MFE_BS_SELECT_PAYMENT_METHOD_CTA_ADD_BANK_ACC`
          : `MFE_BS_SELECT_PAYMENT_METHOD_CTA_ADD_UPI`
      }
      className='flex items-center gap-3 w-full'
    >
      <div className='flex items-center justify-center px-1'>
        <RenderHTML innerHTMLText={isDisabled ? DisabledAddIcon : AddIcon} />
      </div>
      <div className='flex flex-col'>
        <div
          className={`font-[500] text-[14px] ${caption ? 'mb-[2px]' : 'mb-0'} ${isDisabled ? 'text-[#9E9E9E]' : 'text-[#1470CC]'}`}
        >
          {addType === 'bank' ? 'Add bank account' : 'Add UPI ID'}
        </div>
        {caption && <div className='text-[12px] text-[#9E9E9E] font-[400]'>{caption}</div>}
      </div>
    </div>
  )
}

const AddIcon = `<svg width="34" height="26" viewBox="0 0 34 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.000244141" width="33.9976" height="26" rx="10" fill="#DEEEFF"/>
<path d="M21.249 12.2502H18.249C18.1164 12.2502 17.9892 12.1976 17.8955 12.1038C17.8017 12.01 17.749 11.8829 17.749 11.7502V8.75024C17.749 8.55133 17.67 8.36057 17.5294 8.21991C17.3887 8.07926 17.1979 8.00024 16.999 8.00024C16.8001 8.00024 16.6093 8.07926 16.4687 8.21991C16.328 8.36057 16.249 8.55133 16.249 8.75024V11.7502C16.249 11.8829 16.1963 12.01 16.1026 12.1038C16.0088 12.1976 15.8816 12.2502 15.749 12.2502H12.749C12.5501 12.2502 12.3593 12.3293 12.2187 12.4699C12.078 12.6106 11.999 12.8013 11.999 13.0002C11.999 13.1992 12.078 13.3899 12.2187 13.5306C12.3593 13.6712 12.5501 13.7502 12.749 13.7502H15.749C15.8816 13.7502 16.0088 13.8029 16.1026 13.8967C16.1963 13.9905 16.249 14.1176 16.249 14.2502V17.2502C16.249 17.4492 16.328 17.6399 16.4687 17.7806C16.6093 17.9212 16.8001 18.0002 16.999 18.0002C17.1979 18.0002 17.3887 17.9212 17.5294 17.7806C17.67 17.6399 17.749 17.4492 17.749 17.2502V14.2502C17.749 14.1176 17.8017 13.9905 17.8955 13.8967C17.9892 13.8029 18.1164 13.7502 18.249 13.7502H21.249C21.4479 13.7502 21.6387 13.6712 21.7794 13.5306C21.92 13.3899 21.999 13.1992 21.999 13.0002C21.999 12.8013 21.92 12.6106 21.7794 12.4699C21.6387 12.3293 21.4479 12.2502 21.249 12.2502Z" fill="#1470CC" stroke="#1470CC" stroke-width="0.5"/>
</svg>
`

const DisabledAddIcon = `<svg width="34" height="26" viewBox="0 0 34 26" fill="none" xmlns="http://www.w3.org/2000/svg">  
<rect y="0.000244141" width="33.9976" height="26" rx="10" fill="#F5F5F5"/>
<path d="M21.249 12.2502H18.249C18.1164 12.2502 17.9892 12.1976 17.8955 12.1038C17.8017 12.01 17.749 11.8829 17.749 11.7502V8.75024C17.749 8.55133 17.67 8.36057 17.5294 8.21991C17.3887 8.07926 17.1979 8.00024 16.999 8.00024C16.8001 8.00024 16.6093 8.07926 16.4687 8.21991C16.328 8.36057 16.249 8.55133 16.249 8.75024V11.7502C16.249 11.8829 16.1963 12.01 16.1026 12.1038C16.0088 12.1976 15.8816 12.2502 15.749 12.2502H12.749C12.5501 12.2502 12.3593 12.3293 12.2187 12.4699C12.078 12.6106 11.999 12.8013 11.999 13.0002C11.999 13.1992 12.078 13.3899 12.2187 13.5306C12.3593 13.6712 12.5501 13.7502 12.749 13.7502H15.749C15.8816 13.7502 16.0088 13.8029 16.1026 13.8967C16.1963 13.9905 16.249 14.1176 16.249 14.2502V17.2502C16.249 17.4492 16.328 17.6399 16.4687 17.7806C16.6093 17.9212 16.8001 18.0002 16.999 18.0002C17.1979 18.0002 17.3887 17.9212 17.5294 17.7806C17.67 17.6399 17.749 17.4492 17.749 17.2502V14.2502C17.749 14.1176 17.8017 13.9905 17.8955 13.8967C17.9892 13.8029 18.1164 13.7502 18.249 13.7502H21.249C21.4479 13.7502 21.6387 13.6712 21.7794 13.5306C21.92 13.3899 21.999 13.1992 21.999 13.0002C21.999 12.8013 21.92 12.6106 21.7794 12.4699C21.6387 12.3293 21.4479 12.2502 21.249 12.2502Z" fill="#D3D3D3" stroke="#D3D3D3" stroke-width="0.5"/>
</svg>
`
